<div class="progress-container">
  <div class="loading-text">
    {{ currentSentence | translate }}
  </div>
  <kendo-progressbar
    [value]="progressValue"
    [label]="false"
  ></kendo-progressbar>
</div>
